import { Menu } from "@mui/icons-material"
import { IconButton, Stack, Typography } from "@mui/material"
import { useState } from "react"

import Button from "@components/button"
import PageHeader from "@components/page_header"
import { PRIMARY } from "@constants/colors"
import { showErrorToast } from "@utils/toast"

import {
  PasswordFormData,
  useAccountPasswordPageContext
} from "@contexts/account/profile/password"
import { updateUsers } from "@domain/users"
import styles from "./styles"

export default function AccountProfilePasswordPageHeader() {
  const {
    translate,
    isLeftDrawerOpen,
    toggleIsLeftDrawerOpen,
    handleSubmit,
    isValid,
    isDirty,
    me,
    reset
  } = useAccountPasswordPageContext()
  const [loading, setLoading] = useState<boolean>(false)
  async function onSubmit(data: PasswordFormData) {
    setLoading(true)
    if (!me?._id) return
    const {
      isSuccess: isSuccessPhoto,
      errorMessage,
      data: responseData
    } = await updateUsers({
      _id: me._id,
      password: data.newPassword
    })
    if (!isSuccessPhoto || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }
    reset?.(data)
    setLoading(false)
  }

  return (
    <PageHeader backgroundColor={"primary"} sx={styles.content}>
      <Stack direction={"row"} alignItems={"center"} columnGap={1} pl={1}>
        <IconButton
          onClick={toggleIsLeftDrawerOpen}
          disabled={!!isLeftDrawerOpen}
          disableRipple
          sx={{
            display: !!isLeftDrawerOpen ? "none" : "block",
            pl: 0,
            ":hover": {
              color: PRIMARY
            }
          }}
        >
          <Menu />
        </IconButton>

        <Typography variant="h6">{translate("password")}</Typography>
      </Stack>
      <Button
        loading={loading}
        disabled={!isValid || !isDirty}
        onClick={handleSubmit?.(onSubmit)}
      >
        {translate("update")}
      </Button>
    </PageHeader>
  )
}
